import { GridRenderCellParams } from "@mui/x-data-grid";
import { GfShoppingListFlyerItem } from "@swagger/typescript-fetch-goflyer";
import { AllowedTableColumn } from "../../../utils/types/AllowTableTypes";

export const useShoppingListReportTableColumns = () => {
  const values: AllowedTableColumn[] = ["updatedAt", "createdAt"];

  const columns = [
    {
      field: "flyerItem",
      width: 200,
      headerName: "Flyer Item Name",
      sortable: true,
      renderCell: (params: GridRenderCellParams<GfShoppingListFlyerItem>) => {
        return <div>{params.row.flyerItem?.name || "N/A"}</div>;
      },
    },
    {
      field: "addedFrom",
      width: 150,
      headerName: "Added From",
      sortable: true,
      renderCell: (params: GridRenderCellParams<GfShoppingListFlyerItem>) => {
        return <div>{params.row.addedFrom || "N/A"}</div>;
      },
    },
    ...values.map((value) => ({
      field: value,
      width: 200,
      headerName: value === "createdAt" ? "Created At" : "Updated At",
      sortable: true,
      type: "dateTime" as const,
      valueGetter: (val: GridRenderCellParams) => {
        return val && new Date(val?.row[value]);
      },
    })),
    {
      field: "id",
      width: 250,
      headerName: "ID",
      sortable: true,
      filterable: false,
      renderCell: (params: GridRenderCellParams<GfShoppingListFlyerItem>) => {
        return <div>{params.row.id}</div>;
      },
    },
  ];

  return columns;
};
